import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Autoplay, EffectFade } from 'swiper/modules';
import { bannerImages } from '../utils/BeadsData';
import { useImageLoading } from '../hooks/useImageLoading';
import Spinner from '../components/common/Spinner';

const BannerHome = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const coverImage = bannerImages[0];

  // Collect all images from the bannerImages
  const projectImages = useMemo(() => {
    if (!bannerImages) return [];
    const images = bannerImages.map(image => image.src);
    return images;
  }, []);

  const isLoading = useImageLoading(projectImages);

  if (isLoading) {
    return <Spinner />;
  }


  return (
    <Box sx={{ width: '100%', height: '100vh', '.swiper': { width: '100%', height: '100%' } }}>
      {isMobile ? (
        // Display a single cover image for mobile screens
        <Box
          sx={{
            position: 'relative',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& img': {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            },
          }}
        >
          <img src={coverImage.src} alt={coverImage.alt || "Cover Image"} />
          <Typography
            variant="h5"
            component="div"
            sx={{
              position: 'absolute',
              color: '#fff',
              fontWeight: 'bold',
              textAlign: 'center',
              padding: '0 20px',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
            }}
          >
            {coverImage.description}
          </Typography>
        </Box>
      ) : (
        // Display the Swiper carousel for non-mobile screens
        <Swiper
          modules={[Autoplay, EffectFade]}
          // spaceBetween={50}
          // slidesPerView={1}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}

        >
          {bannerImages.map((image, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  position: 'relative',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    '@media (max-width:600px)': {
                      objectFit: 'cover',
                    },
                  },
                }}
              >
                <img src={image.src} alt={image.alt || `Slide ${index}`} />
                <Typography
                  variant="h5"
                  component="div"
                  sx={{
                    position: 'absolute',
                    color: '#fff',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    padding: '0 20px',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                  }}
                >
                  {image.description}
                </Typography>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      )};
    </Box>
  );
};

export default BannerHome;